import { RichContent } from '@corratech/pylot-rich-content'
import { memo, ReactElement } from 'react'
import s from '@pagestyles/PDP.module.scss'

type ProductInfoProps = {
    description?: {
        html?: string
    }
}

const ProductInfoComponent = ({
    description = {}
}: ProductInfoProps): ReactElement | null => {
    const { html } = description

    if (!html) {
        return null
    }

    return (
        <div className={s['pdp-info-wrap']}>
            <RichContent html={html} />
        </div>
    )
}

export const ProductInfo = memo(ProductInfoComponent)
